fragment CalcuraExecutionFragment on CalcuraExecution {
    visibilityLogicData
    mediaLogicData
    errorsData
    logicLogInfo
    outputData
}